import React from 'react';
import type { Profile } from '@interlucent/organization-protocol';
import { ProfileCard } from './ProfileCard';
import { useStore } from '../../store';
import styles from './ProfileList.module.css';

interface ProfileListProps {
  projectId: string;
  profiles: Profile[];
  onEdit: (profile: Profile) => void;
  onDelete: (profileId: string, profileName: string) => void;
  onToggleStatus: (profileId: string, isActive: boolean) => void;
  onManageMappings: (profileId: string) => void;
}

export function ProfileList({
  projectId,
  profiles,
  onEdit,
  onDelete,
  onToggleStatus,
  onManageMappings,
}: ProfileListProps) {
  // Resolver-correct coverage from the WS snapshot (pool_materialized_entries
  // via `coveringPools`) — the same slice the app cards and app-detail pills
  // read, and live-updated on AppPoolCoverageChanged.
  const appPoolCoverage = useStore(s => s.appPoolCoverage);
  if (profiles.length === 0) {
    return (
      <div className={styles.empty}>
        <p className={styles.emptyText}>
          No deployment profiles yet. Create one to get started.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {profiles.map(profile => {
        // Mapped-app count from MATERIALIZED coverage — the same truth the
        // session-request preflight uses.
        const mappingCount = Object.values(appPoolCoverage)
          .filter(pools => pools.some(p => p.poolId === profile.id)).length;

        return (
          <ProfileCard
            key={profile.id}
            profile={profile}
            projectId={projectId}
            mappingCount={mappingCount}
            onEdit={onEdit}
            onDelete={onDelete}
            onToggleStatus={onToggleStatus}
            onManageMappings={onManageMappings}
          />
        );
      })}
    </div>
  );
}
